import { useQuery } from "react-query";
import { getMeterPointReadings } from "../services/meterpoints/readings";

export const useMeterPointReadings = (meterPointId: number | string) => {
  return useQuery(
    ["meterpoints/readings", meterPointId],
    getMeterPointReadings,
    { enabled: !!meterPointId },
  );
};
